import { render, staticRenderFns } from "./CardProduto.vue?vue&type=template&id=0a9fc933&scoped=true&"
import script from "./CardProduto.vue?vue&type=script&lang=js&"
export * from "./CardProduto.vue?vue&type=script&lang=js&"
import style0 from "./CardProduto.vue?vue&type=style&index=0&id=0a9fc933&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9fc933",
  null
  
)

export default component.exports